import React, { useEffect, useCallback } from "react";
import { wrapper } from "@/redux/Store";

import AnnualMembershipPage from "@/containers/AnnualMembershipPage";
import { useAppDispatch } from "@/hooks";
import { getMembershipBenefitData } from "@/redux/AnnualMembershipAndDoctorsCareBenefitReducer";

function AnnualMembership() {
  const dispatch = useAppDispatch();
  const slug = "annual-membership";

  const getAnnualMembershipPageData = useCallback(
    () => dispatch(getMembershipBenefitData(slug)),
    [slug]
  );

  useEffect(() => {
    getAnnualMembershipPageData();
  }, []);
  return <AnnualMembershipPage />;
}

export default AnnualMembership;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(getMembershipBenefitData("annual-membership"));
  }
);
